import { Switch } from 'react-native-paper'
import { DS } from '../../design-system'
import { useEffect, useState } from 'react'
import { StyleSheet, Platform } from 'react-native'

type NotificationScheduleProps = {
  _id: string
  title: string
  enabled: boolean
  isPermissionEnabled: boolean
  toggleNotification: (id: string, value: boolean) => void
  subtitle?: string
}

export const NotificationSchedule = ({
  _id,
  title,
  enabled,
  subtitle,
  isPermissionEnabled,
  toggleNotification
}: NotificationScheduleProps) => {
  const [on, setOn] = useState(enabled)

  const textOn = subtitle ? `On - ${subtitle}` : 'On'
  const textOff = subtitle ? `Off - ${subtitle}` : 'Off'

  useEffect(() => {
    setOn(enabled)
  }, [enabled])

  return (
    <DS.Frame row gap="16">
      <DS.Frame flex={1}>
        <DS.Text variant="Heading 5/Regular" color="Global/Black">
          {title}
        </DS.Text>
        <DS.Text variant="Caption/Regular" color="Brand/Dark Grey">
          {enabled ? textOn : textOff}
        </DS.Text>
      </DS.Frame>

      <Switch
        onValueChange={(value) => {
          if (isPermissionEnabled) {
            toggleNotification(_id, value)
            setOn(value)
          } else {
            setOn(false)
            toggleNotification(_id, value)
          }
        }}
        style={styles.switchContainer}
        value={isPermissionEnabled && on}
        thumbColor={DS.palette['Global/White']}
        trackColor={{
          false: DS.palette['Brand/Light Grey'],
          true: DS.palette['Brand/Maroon']
        }}
      />
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  switchContainer: {
    marginLeft: 16,
    ...Platform.select({
      ios: {
        transform: [{ scaleX: 1 }, { scaleY: 1 }]
      },
      android: {
        transform: [{ scaleX: 1.3 }, { scaleY: 1.3 }]
      }
    })
  }
})
